enum DELIVERYADDRESS_CONSTANTS {
    ADDADDRESS_BEGIN = "ADDADDRESS_BEGIN",
    ADDADDRESS_ERROR = "ADDADDRESS_ERROR",
    ADDADDRESS_SUCCESS = "ADDADDRESS_SUCCESS",

    DELIVERYADDRESS_CLEAR = "DELIVERYADDRESS_CLEAR",

    ////////GET ADDRESS     
    GETADDRESS_BEGIN = "GETADDRESS_BEGIN",
    GETADDRESS_ERROR = "GETADDRESS_ERROR",
    GETADDRESS_SUCCESS = "GETADDRESS_SUCCESS",

    ///////VERIFY ZIP CODE

    VERIFYZIP_BEGIN = "VERIFYZIP_BEGIN",
    VERIFYZIP_ERROR = "VERIFYZIP_ERROR",
    VERIFYZIP_SUCCESS = "VERIFYZIP_SUCCESS",
    VERIFY_CLEAR = "VERIFYZIP_CLEAR",

}

export default DELIVERYADDRESS_CONSTANTS